module.exports = __webpack_public_path__ + "img/3DSProjectInstallCIA.bd62f0fc.jpg";